import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { Carousel } from 'react-responsive-carousel';
import renderDotIndicator from "../../../helpers/render-dot-indicator"
import Testimonial1 from "../../../images/icons/aryan _jalan _seo consultant.png"


const StyledContainer = styled(Container)`
 #ef-h1{
    color: #334a4a !important;
    line-height: 1.2em ;
    font-weight: 400;
    text-align:center;
    font-size: 40px !important;
 }

 .carousel-root {
    width: 64% !important;
    margin: auto !important;
    margin-top: 3% !important;
  }
  
  .carousel .slide {
    background: #fff !important;
    color: black;
    height: 100%;
  }
  
  .carousel .slide img {
    width: 84px !important;
    border-radius: 50%;
  }
  
  .myCarousel {
    margin-top: -6%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 6%;
    padding-bottom: 8%;
    padding-left: 5%;
    padding-right: 5%;
    // height: 300px;
  }
  
  .carousel .control-dots {
    padding-left: 5px !important;
    outline: 0;
    bottom: 5% !important;
  }
  
  .myCarousel h3 {
    color: #222;
    font-weight: 100;
    letter-spacing: 0.2px;
    margin-bottom: 4px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 17px;
  }
  
  .myCarousel h4 {
    text-transform: uppercase;
    margin-top: 0;
    padding-top: 0;
    font-weight: 500;
    color: #787878;
    font-size: 14px;
  }
  
  .myCarousel p {
    font-size: 14px;
    color: #334a4a ;
    letter-spacing: 0.2px;
    font-weight: 400;
  }
 
  .myCarousel .discription:before {
    content: "“";
    color: #334a4a;
    font-size: 26px;
    font-weight: 100;
  }
  
  .myCarousel .discription:after {
    content: "”";
    color: #334a4a;
    font-size: 26px;
    font-weight: 100;
    line-height: 0;
  }
  
  .carousel .control-dots .dot {
    box-shadow: none !important;
    background: #454545 !important;
    outline: 0;
  }
  
  .carousel.carousel-slider .control-arrow {
    background: #000 !important;
    height: 50px !important;
    position: absolute;
    top: 35% !important;
  }
  
  .App {
    text-align: center;
  }

  .control-prev.control-arrow{
    display: none;
  }

  .control-arrow.control-next{
    display: none;
  }

  h3{
    padding-top:15px;
  }
  
  @media only screen and (max-width: 934px) {
    .carousel-root {
      outline: 0;
      width: 100% !important;
      margin: auto !important;
      text-decoration: none;
    }
  
    .carousel.carousel-slider .control-arrow {
      display: none !important;
    }

    .myCarousel {
      background: #fafafa;
      margin-top: -9%;
      width: 88%;
      margin-left: auto;
      margin-right: auto;
      padding-top: 8%;
      padding-bottom: 12.5%;
      padding-left: 5%;
      padding-right: 5%;
      // height: 400px;
    }
  
    .carousel .slide img {
      border-radius: 50%;
    }
  }

`

const Testimonials = () => {

  return (
    <StyledContainer>
      <div className="ds-container">
        <h2 className="text-center fw-bold">Testimonials</h2>
      </div>
      <Carousel
        useKeyboardArrows={true}
        showArrows={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={3100}
        renderIndicator={renderDotIndicator}
      >
        <div>
          <img loading="lazy" src="https://clearout.io/wp-content/uploads/2021/09/paul-main-150x150-1.jpeg" alt="SigParser" width={84} height={84} />
          <div className="myCarousel">
            <span className="fw-bold">SigParser</span>
            <p className="fw-bold">Paul Mendoza, Co-founder</p>
            <p className="discription">
              It works amazingly well at validating email addresses with great API and support. It was able to identify about 10% of the invalid contacts in our database. There are other products for email verification but Clearout by far has the best price and easiest to use
            </p>
          </div>
        </div>
        <div>
          <img loading="lazy" src="https://clearout.io/wp-content/uploads/2018/01/hayk-headshot-150x150.jpg" alt="Logic Inbound" width={84} height={84} />
          <div className="myCarousel">
            <span className="fw-bold">Logic Inbound</span>
            <p className="fw-bold">Hayk Saakian, Cofounder and COO</p>
            <p className="discription">
              After trying Clearout email tester, I almost never see any bounces or failed deliveries and our open rate is as high as 82% sometimes because the quality of our list is so good now. The "guaranteed deliverables" feature gives us a lot of confidence in Clearout as a product
            </p>
          </div>
        </div>
        <div>
          <img loading="lazy" src="https://clearout.io/wp-content/uploads/2018/01/Headshot-2-150x150.jpg" alt="Pearl Lemon" width={84} height={84} />
          <div className="myCarousel">
            <span className="fw-bold">Pearl Lemon</span>
            <p className="fw-bold">Deepak, Founder</p>
            <p className="discription">
              Clearout email verifier has proven to be an excellent resource to help us clean emails, as a lead generation agency. Increasing our deliverability by 23%, it s now part of our go-to tool stack for outreach campaigns</p>
          </div>
        </div>
        <div>
          <img loading="lazy" src={Testimonial1} alt="Pearl Lemon" width={84} height={84} />
          <div className="myCarousel">
            <span className="fw-bold">Freelancing</span>
            <p className="fw-bold">Aryan Jalan, SEO Consultant</p>
            <p className="discription">
             Clearout is top-notch! It's not only affordable, but also effective. It keeps my emails from going to spam and finds new clients for me. I've seen fewer emails bounce back, and more of them reach their intended destination. Compared to Neverbounce, Clearout takes the lead. It's really boosted my email open rates. Truly, Clearout is a game changer for my email marketing activities!</p>
          </div>
        </div>
      </Carousel>
    </StyledContainer>
  )
}

export default Testimonials;